/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Empty_BodyInputs */

const en_help_empty_body = /** @type {(inputs: Help_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step-by-step articles on your calendar, clients, plans and payments will live here. Until then, ask us directly.`)
};

const pl_help_empty_body = /** @type {(inputs: Help_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu pojawią się instrukcje krok po kroku o kalendarzu, podopiecznych, planach i płatnościach. Do tego czasu zapytaj nas bezpośrednio.`)
};

/**
* | output |
* | --- |
* | "Step-by-step articles on your calendar, clients, plans and payments will live here. Until then, ask us directly." |
*
* @param {Help_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_empty_body = /** @type {((inputs?: Help_Empty_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Empty_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_empty_body(inputs)
	return en_help_empty_body(inputs)
});